import { View, Pressable } from "react-native";
import { Text } from "react-native-paper";
import { Feather } from "@expo/vector-icons";
import { Button, Modal } from "../../../components";
import { colors } from "../../../../theme";

export default function DateOfBirthModal({ visible, onDismiss }: { visible: boolean; onDismiss: () => void }) {
  return (
    <Modal visible={visible} onDismiss={onDismiss} title="" hasBorder={false} HeaderComponent={<View />}>
      <View className="p-6">
        <Text className="text-large-normal font-700 mb-4">Date of birth is not editable.</Text>
        <Text className="text-regular-normal">
          The date shown is the date of birth we have on file for{"\n"}
          you. If it's incorrect, please contact membership services{"\n"}
          online or by phone at 800-474-2776.
        </Text>
        <View className="mt-6 self-end">
          <Button size="small" mode="secondary" onPress={onDismiss}>
            Close
          </Button>
        </View>
      </View>
    </Modal>
  );
}

export const DateOfBirthInfoButton = ({ onPress }: { onPress(): void }) => (
  <Pressable style={{ position: "absolute", right: 10, top: 15 }} onPress={onPress} testID="age-info-button">
    <Feather name="info" color={colors.ink.lighter} size={16} />
  </Pressable>
);
